import axios from 'axios';
import { uploadPhotoUrl } from '../constants';


export function uploadPhoto(modificationId: number, files: FormData) {
  return axios.post(uploadPhotoUrl(modificationId), files, {
    headers: { 'content-type': 'multipart/form-data' },
  });
}
